// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GeneratePage-root {
  min-height: calc(100vh - 60px);
  margin-left: 88px;
  color: var(--canvas-ink, #171a17);
  background: #f3f5f6;
}

.GeneratePage-root .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.GeneratePage-main {
  width: min(1540px, 100%);
  margin: 0 auto;
  padding: 18px 30px 34px;
}

.GeneratePage-header {
  display: flex;
  min-height: 46px;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--canvas-line, #e2e6e4);
}

.GeneratePage-header h1 {
  margin: 0;
  color: var(--canvas-ink, #171a17);
  font-size: 28px;
  font-weight: 750;
  letter-spacing: -0.02em;
  line-height: 1.12;
}

.GeneratePage-header p {
  margin: 9px 0 0;
  color: var(--canvas-muted, #737b75);
  font-size: 13px;
  line-height: 1.5;
}

.GeneratePage-workspace {
  display: grid;
  grid-template-columns: minmax(330px, 390px) minmax(0, 1fr);
  align-items: start;
  gap: 20px;
  padding-top: 16px;
}

.GeneratePage-controls,
.GeneratePage-results {
  min-width: 0;
  background: #fff;
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 14px;
}

.GeneratePage-controls {
  position: sticky;
  top: 76px;
  padding: 16px 18px 15px;
}

.GeneratePage-section {
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid #edf0ee;
}

.GeneratePage-section-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 9px;
}

.GeneratePage-section-heading h2,
.GeneratePage-results-header h2 {
  margin: 0;
  color: var(--canvas-ink, #171a17);
  font-size: 15px;
  font-weight: 720;
  letter-spacing: -0.01em;
  line-height: 1.3;
}

.GeneratePage-section-heading p,
.GeneratePage-results-header p {
  margin: 3px 0 0;
  color: var(--canvas-muted, #737b75);
  font-size: 10px;
  line-height: 1.45;
}

.GeneratePage-result-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 3px 9px;
}

.GeneratePage-task-id {
  overflow-wrap: anywhere;
  color: #66746a;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-size: 9px;
}

.GeneratePage-section-count,
.GeneratePage-required {
  flex: 0 0 auto;
  color: #6f7971;
  font-size: 10px;
  line-height: 1.4;
}

.GeneratePage-required {
  color: #b65a42;
}

.GeneratePage-model-tabs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
  margin-bottom: 8px;
}

.GeneratePage-model-tab {
  display: flex;
  min-height: 31px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 5px 8px;
  color: #758078;
  background: #f7f9f7;
  border: 1px solid #e5ebe6;
  border-radius: 7px;
  font-size: 10px;
  font-weight: 700;
  transition: color 160ms ease, background 160ms ease, border-color 160ms ease;
}

.GeneratePage-model-tab small {
  min-width: 16px;
  padding: 2px 4px;
  color: #849087;
  background: #e9eeea;
  border-radius: 4px;
  font-size: 8px;
  line-height: 1;
}

.GeneratePage-model-tab:hover:not(:disabled) {
  color: #36512d;
  border-color: #c7dbbd;
}

.GeneratePage-model-tab.is-selected {
  color: #315327;
  background: #eaf5df;
  border-color: #b9df8a;
}

.GeneratePage-model-tab.is-selected small {
  color: #4b7335;
  background: #d8edc2;
}

.GeneratePage-model-picker {
  position: relative;
}

.GeneratePage-model-picker-trigger {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) auto;
  align-items: center;
  gap: 9px;
  width: 100%;
  min-height: 60px;
  padding: 9px 10px;
  color: var(--canvas-ink, #171a17);
  background: #fbfcfb;
  border: 1px solid #d7e1d9;
  border-radius: 9px;
  text-align: left;
  transition: border-color 160ms ease, background 160ms ease, box-shadow 160ms ease;
}

.GeneratePage-model-picker-trigger:hover:not(:disabled),
.GeneratePage-model-picker-trigger.is-open {
  background: #f7faf6;
  border-color: var(--model-accent, #70a33d);
  box-shadow: 0 4px 12px rgba(24, 30, 26, 0.06);
}

.GeneratePage-model-picker-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.GeneratePage-model-picker-copy strong {
  overflow: hidden;
  font-size: 12px;
  font-weight: 720;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.GeneratePage-model-picker-copy small {
  overflow: hidden;
  color: var(--canvas-muted, #737b75);
  font-size: 9px;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.GeneratePage-model-picker-action {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #6c776f;
  font-size: 9px;
  font-weight: 700;
}

.GeneratePage-model-picker-trigger.is-open .GeneratePage-model-picker-action i {
  transform: rotate(180deg);
}

.GeneratePage-model-picker-action i {
  transition: transform 160ms ease;
}

.GeneratePage-model-menu {
  position: absolute;
  z-index: 30;
  top: calc(100% + 7px);
  right: 0;
  left: 0;
  padding: 7px;
  background: rgba(255, 255, 255, 0.99);
  border: 1px solid var(--canvas-line-strong, #ccd2ce);
  border-radius: 10px;
  box-shadow: 0 16px 36px rgba(24, 30, 26, 0.14);
  animation: GeneratePage-menu-enter 130ms ease-out;
}

.GeneratePage-model-menu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 5px 7px;
  color: #4d5a50;
  font-size: 10px;
  font-weight: 700;
}

.GeneratePage-model-menu-header small {
  color: #88928b;
  font-size: 9px;
  font-weight: 500;
}

.GeneratePage-model-menu-list {
  display: grid;
  gap: 5px;
  max-height: min(360px, calc(100vh - 180px));
  overflow-y: auto;
  padding-right: 1px;
  scrollbar-width: thin;
}

.GeneratePage-model-option {
  position: relative;
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) 15px;
  align-items: start;
  gap: 8px;
  width: 100%;
  min-height: 57px;
  padding: 9px;
  color: var(--canvas-ink, #171a17);
  background: #fbfcfb;
  border: 1px solid #e4e9e5;
  border-radius: 8px;
  text-align: left;
  transition: border-color 160ms ease, background 160ms ease, box-shadow 160ms ease;
}

.GeneratePage-model-option:hover:not(:disabled) {
  background: #f5f8f3;
  border-color: #c3d9b5;
}

.GeneratePage-model-option.is-selected {
  background: color-mix(in srgb, var(--model-accent) 7%, #fff);
  border-color: var(--model-accent);
  box-shadow: 0 5px 14px rgba(24, 30, 26, 0.06);
}

.GeneratePage-model-option:focus-visible,
.GeneratePage-model-picker-trigger:focus-visible,
.GeneratePage-model-tab:focus-visible,
.GeneratePage-option-trigger:focus-visible,
.GeneratePage-option-list button:focus-visible,
.GeneratePage-params-toggle:focus-visible,
.GeneratePage-quality-options button:focus-visible,
.GeneratePage-reference-add:focus-visible,
.GeneratePage-reference-remove:focus-visible,
.GeneratePage-audio-toggle:focus-within,
.GeneratePage-submit:focus-visible,
.GeneratePage-clear-button:focus-visible,
.GeneratePage-error-state button:focus-visible,
.GeneratePage-history-login:focus-visible,
.GeneratePage-history-retry:focus-visible,
.GeneratePage-history-load-more:focus-visible,
.GeneratePage-media-result figcaption a:focus-visible {
  outline: 2px solid var(--canvas-green-strong, #70a33d);
  outline-offset: 2px;
}

.GeneratePage-model-option:disabled,
.GeneratePage-model-tab:disabled,
.GeneratePage-model-picker-trigger:disabled,
.GeneratePage-option-trigger:disabled,
.GeneratePage-quality-options button:disabled,
.GeneratePage-submit:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.GeneratePage-model-mark {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  color: var(--model-accent);
  background: color-mix(in srgb, var(--model-accent) 11%, #fff);
  border-radius: 8px;
  font-size: 14px;
}

.GeneratePage-model-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.GeneratePage-model-copy strong {
  font-size: 11px;
  font-weight: 720;
  line-height: 1.3;
}

.GeneratePage-model-copy small {
  overflow: hidden;
  color: var(--canvas-muted, #737b75);
  font-size: 9px;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.GeneratePage-model-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 1px;
}

.GeneratePage-model-tags em {
  padding: 2px 4px;
  color: #6a746d;
  background: #eef1ee;
  border-radius: 4px;
  font-size: 7px;
  font-style: normal;
  line-height: 1;
}

.GeneratePage-model-check {
  padding-top: 2px;
  color: var(--model-accent);
  font-size: 14px;
  opacity: 0;
}

.GeneratePage-model-option.is-selected .GeneratePage-model-check {
  opacity: 1;
}

.GeneratePage-prompt-field {
  position: relative;
  display: block;
}

.GeneratePage-prompt-field textarea {
  display: block;
  width: 100%;
  height: 104px;
  min-height: 104px;
  max-height: 104px;
  resize: none;
  padding: 10px 11px 27px;
  color: var(--canvas-ink, #171a17);
  background: #fbfcfb;
  border: 1px solid #dfe5e1;
  border-radius: 9px;
  font-size: 11px;
  line-height: 1.55;
  outline: none;
  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.GeneratePage-prompt-field textarea::placeholder {
  color: #8b938d;
}

.GeneratePage-prompt-field textarea:hover:not(:disabled) {
  border-color: #bfcac1;
}

.GeneratePage-prompt-field textarea:focus {
  background: #fff;
  border-color: var(--canvas-green-strong, #70a33d);
  box-shadow: 0 0 0 3px rgba(112, 163, 61, 0.13);
}

.GeneratePage-prompt-field textarea:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.GeneratePage-prompt-count {
  position: absolute;
  right: 11px;
  bottom: 10px;
  color: #909991;
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 9px;
}

.GeneratePage-reference-section .GeneratePage-section-heading {
  margin-bottom: 6px;
}

.GeneratePage-reference-section .GeneratePage-section-heading p {
  max-width: 270px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.GeneratePage-reference-actions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(88px, 1fr));
  gap: 5px;
}

.GeneratePage-reference-action {
  min-width: 0;
}

.GeneratePage-reference-add {
  display: flex;
  min-height: 31px;
  align-items: center;
  gap: 5px;
  width: 100%;
  padding: 5px 7px;
  color: #5f6d63;
  background: #fbfcfb;
  border: 1px solid #dfe7e0;
  border-radius: 7px;
  font-size: 9px;
  font-weight: 680;
  text-align: left;
  transition: color 160ms ease, background 160ms ease, border-color 160ms ease;
}

.GeneratePage-reference-add > i {
  flex: 0 0 auto;
  color: #6d9a52;
  font-size: 11px;
}

.GeneratePage-reference-add span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.GeneratePage-reference-add small {
  margin-left: auto;
  color: #8a958d;
  font-size: 8px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.GeneratePage-reference-add:hover:not(:disabled) {
  color: #36512d;
  background: #f0f7eb;
  border-color: #bcd7ac;
}

.GeneratePage-reference-add:disabled {
  cursor: not-allowed;
  opacity: 0.52;
}

.GeneratePage-reference-input {
  display: none;
}

.GeneratePage-reference-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 5px;
  color: #8a958d;
  font-size: 8px;
  line-height: 1.35;
}

.GeneratePage-reference-meta span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.GeneratePage-reference-meta span:first-child {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.GeneratePage-reference-meta i {
  color: #6c9953;
}

.GeneratePage-reference-notice,
.GeneratePage-reference-error {
  display: flex;
  align-items: flex-start;
  gap: 5px;
  margin-top: 5px;
  font-size: 8px;
  line-height: 1.4;
}

.GeneratePage-reference-notice {
  color: #8b6c2e;
}

.GeneratePage-reference-error {
  color: #ae5a4c;
}

.GeneratePage-reference-notice i,
.GeneratePage-reference-error i {
  flex: 0 0 auto;
  padding-top: 1px;
}

.GeneratePage-reference-list {
  display: grid;
  max-height: 112px;
  gap: 4px;
  margin-top: 6px;
  overflow-y: auto;
  padding-right: 2px;
  scrollbar-width: thin;
}

.GeneratePage-reference-item {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) 22px;
  align-items: center;
  gap: 7px;
  min-width: 0;
  min-height: 36px;
  padding: 3px 4px;
  background: #f7faf6;
  border: 1px solid #e4ece2;
  border-radius: 6px;
}

.GeneratePage-reference-preview {
  position: relative;
  display: grid;
  width: 34px;
  height: 28px;
  place-items: center;
  overflow: hidden;
  color: #779b5f;
  background: #eaf3e5;
  border-radius: 4px;
  font-size: 12px;
}

.GeneratePage-reference-item.is-video .GeneratePage-reference-preview {
  color: #7a6b91;
  background: #f0ecf6;
}

.GeneratePage-reference-item.is-audio .GeneratePage-reference-preview {
  color: #a06a35;
  background: #fff1df;
}

.GeneratePage-reference-preview img,
.GeneratePage-reference-preview video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.GeneratePage-reference-preview video {
  background: #171b17;
  object-fit: contain;
}

.GeneratePage-reference-uploading,
.GeneratePage-reference-ready {
  position: absolute;
  right: 2px;
  bottom: 2px;
  display: grid;
  min-width: 12px;
  height: 12px;
  place-items: center;
  padding: 0 2px;
  color: #fff;
  background: #5b8250;
  border-radius: 3px;
  font-size: 7px;
  line-height: 1;
}

.GeneratePage-reference-uploading {
  background: #9a6a1e;
}

.GeneratePage-reference-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}

.GeneratePage-reference-copy strong,
.GeneratePage-reference-copy small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.GeneratePage-reference-copy strong {
  color: #465749;
  font-size: 9px;
  font-weight: 700;
}

.GeneratePage-reference-copy small {
  color: #8a958d;
  font-size: 8px;
}

.GeneratePage-reference-remove {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  color: #8a958d;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 9px;
}

.GeneratePage-reference-remove:hover:not(:disabled) {
  color: #a84f45;
  background: #fff0ed;
  border-color: #f0d0ca;
}

.GeneratePage-reference-remove:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.GeneratePage-reference-list::-webkit-scrollbar {
  width: 5px;
}

.GeneratePage-reference-list::-webkit-scrollbar-thumb {
  background: #cbd8c9;
  border-radius: 999px;
}

.GeneratePage-field-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.GeneratePage-option-field,
.GeneratePage-choice-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
  margin: 0;
}

.GeneratePage-option-field > span,
.GeneratePage-choice-field legend {
  padding: 0;
  color: #5f6961;
  font-size: 9px;
  font-weight: 650;
}

.GeneratePage-option-menu {
  position: relative;
  min-width: 0;
}

.GeneratePage-option-trigger {
  display: flex;
  min-height: 35px;
  align-items: center;
  justify-content: space-between;
  gap: 7px;
  width: 100%;
  padding: 0 9px;
  color: var(--canvas-ink, #171a17);
  background: #fbfcfb;
  border: 1px solid #dfe5e1;
  border-radius: 8px;
  font-size: 10px;
  outline: none;
  text-align: left;
  transition: border-color 160ms ease, background 160ms ease, box-shadow 160ms ease;
}

.GeneratePage-option-trigger:hover:not(:disabled),
.GeneratePage-option-menu.is-open .GeneratePage-option-trigger {
  background: #fff;
  border-color: #b7c9b7;
}

.GeneratePage-option-trigger > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.GeneratePage-option-trigger > i {
  flex: 0 0 auto;
  color: #77847b;
  font-size: 10px;
  transition: transform 160ms ease;
}

.GeneratePage-option-menu.is-open .GeneratePage-option-trigger > i {
  transform: rotate(180deg);
}

.GeneratePage-option-list {
  position: absolute;
  z-index: 25;
  top: calc(100% + 6px);
  right: 0;
  left: 0;
  display: grid;
  gap: 3px;
  min-width: 150px;
  max-height: 270px;
  overflow-y: auto;
  padding: 5px;
  background: #fff;
  border: 1px solid var(--canvas-line-strong, #ccd2ce);
  border-radius: 8px;
  box-shadow: 0 12px 28px rgba(24, 30, 26, 0.13);
  animation: GeneratePage-menu-enter 130ms ease-out;
}

.GeneratePage-option-list button {
  position: relative;
  display: flex;
  min-height: 31px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 7px;
  color: #5f6c63;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 10px;
  text-align: left;
}

.GeneratePage-option-list button:hover,
.GeneratePage-option-list button.is-selected {
  color: #315327;
  background: #eef7e8;
  border-color: #d4e8c8;
}

.GeneratePage-option-list button small {
  margin-left: auto;
  color: #8a958d;
  font-size: 8px;
}

.GeneratePage-option-list button > i {
  flex: 0 0 auto;
  color: var(--canvas-green-strong, #70a33d);
  font-size: 11px;
}

.GeneratePage-choice-field {
  margin-top: 10px;
}

.GeneratePage-quality-options {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 5px;
}

.GeneratePage-quality-options button {
  display: flex;
  min-height: 43px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;
  padding: 6px 7px;
  color: #637066;
  background: #fbfcfb;
  border: 1px solid #dfe5e1;
  border-radius: 7px;
  text-align: left;
}

.GeneratePage-quality-options button:hover:not(:disabled) {
  border-color: #bfcfb6;
}

.GeneratePage-quality-options button.is-selected {
  color: #355227;
  background: #eff8e8;
  border-color: #abd07f;
}

.GeneratePage-quality-options strong {
  font-size: 9px;
  font-weight: 720;
}

.GeneratePage-quality-options small {
  font-size: 8px;
  line-height: 1.3;
}

.GeneratePage-audio-toggle {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 7px;
  margin-top: 9px;
  padding: 4px 6px;
  color: #5e6d62;
  border-radius: 6px;
  font-size: 9px;
  font-weight: 650;
}

.GeneratePage-audio-toggle input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.GeneratePage-toggle-track {
  position: relative;
  display: inline-flex;
  width: 25px;
  height: 15px;
  align-items: center;
  padding: 2px;
  background: #cfd8d0;
  border-radius: 999px;
  transition: background 160ms ease;
}

.GeneratePage-toggle-track i {
  display: block;
  width: 11px;
  height: 11px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(24, 30, 26, 0.16);
  transition: transform 160ms ease;
}

.GeneratePage-audio-toggle input:checked + .GeneratePage-toggle-track {
  background: var(--canvas-green-strong, #70a33d);
}

.GeneratePage-audio-toggle input:checked + .GeneratePage-toggle-track i {
  transform: translateX(10px);
}

.GeneratePage-audio-toggle input:disabled + .GeneratePage-toggle-track,
.GeneratePage-audio-toggle:has(input:disabled) {
  cursor: not-allowed;
  opacity: 0.55;
}

.GeneratePage-params-toggle {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 38px;
  padding: 0;
  color: var(--canvas-ink, #171a17);
  background: transparent;
  border: 0;
  text-align: left;
}

.GeneratePage-params-toggle:hover:not(:disabled) .GeneratePage-params-toggle-copy strong {
  color: #36512d;
}

.GeneratePage-params-toggle:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.GeneratePage-params-toggle-mark {
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  color: #668d4f;
  background: #edf5e8;
  border-radius: 7px;
  font-size: 12px;
}

.GeneratePage-params-toggle-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}

.GeneratePage-params-toggle-copy strong {
  overflow: hidden;
  color: var(--canvas-ink, #171a17);
  font-size: 11px;
  font-weight: 720;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: color 160ms ease;
}

.GeneratePage-params-toggle-copy small {
  overflow: hidden;
  color: #7c887f;
  font-size: 8px;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.GeneratePage-params-toggle-action {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #708071;
}

.GeneratePage-params-toggle-action em {
  font-size: 8px;
  font-style: normal;
  font-weight: 700;
}

.GeneratePage-params-toggle-action i {
  font-size: 10px;
  transition: transform 160ms ease;
}

.GeneratePage-params-section.is-open .GeneratePage-params-toggle-action i {
  transform: rotate(180deg);
}

.GeneratePage-params-panel {
  padding-top: 8px;
  animation: GeneratePage-menu-enter 130ms ease-out;
}

.GeneratePage-parameter-note {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 9px;
  color: #717d74;
  font-size: 9px;
  line-height: 1.45;
}

.GeneratePage-parameter-note i {
  padding-top: 1px;
  color: var(--canvas-green-strong, #70a33d);
}

.GeneratePage-submit-area {
  display: grid;
  gap: 8px;
}

.GeneratePage-quote {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 39px;
  padding: 6px 8px;
  color: #68736b;
  background: #f7f9f7;
  border: 1px solid #e7ece8;
  border-radius: 8px;
}

.GeneratePage-quote-icon {
  display: grid;
  width: 23px;
  height: 23px;
  flex: 0 0 23px;
  place-items: center;
  color: #6a9e39;
  background: #e6f2d8;
  border-radius: 6px;
  font-size: 11px;
}

.GeneratePage-quote > span:last-child {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 1px;
}

.GeneratePage-quote strong {
  color: #465749;
  font-size: 9px;
  font-weight: 700;
}

.GeneratePage-quote small {
  color: #89938b;
  font-size: 8px;
}

.GeneratePage-submit {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  width: 100%;
  color: #fff;
  background: var(--canvas-ink, #171a17);
  border: 1px solid var(--canvas-ink, #171a17);
  border-radius: 8px;
  font-size: 11px;
  font-weight: 720;
  transition: color 160ms ease, background 160ms ease, border-color 160ms ease, transform 160ms ease;
}

.GeneratePage-submit:hover:not(:disabled) {
  color: var(--canvas-ink, #171a17);
  background: var(--canvas-green-soft, #e3f3cb);
  border-color: var(--canvas-green, #b9df8a);
  transform: translateY(-1px);
}

.GeneratePage-spin {
  animation: GeneratePage-spin 0.9s linear infinite;
}

.GeneratePage-results {
  display: flex;
  height: clamp(560px, calc(100vh - 104px), 720px);
  min-height: 560px;
  max-height: 720px;
  flex-direction: column;
  padding: 18px;
  overflow: hidden;
}

.GeneratePage-results-header {
  display: flex;
  flex: 0 0 auto;
  min-height: 46px;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 17px;
  border-bottom: 1px solid #edf0ee;
}

.GeneratePage-result-actions {
  display: inline-flex;
  align-items: center;
  gap: 9px;
}

.GeneratePage-status {
  display: inline-flex;
  height: 24px;
  align-items: center;
  gap: 6px;
  padding: 0 9px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 700;
}

.GeneratePage-status i {
  width: 5px;
  height: 5px;
  background: currentColor;
  border-radius: 50%;
}

.GeneratePage-status.is-pending,
.GeneratePage-status.is-processing {
  color: #9a6a1e;
  background: #fff6df;
}

.GeneratePage-status.is-completed {
  color: #4c7a2f;
  background: #e9f5df;
}

.GeneratePage-status.is-failed {
  color: #b55249;
  background: #fbe9e6;
}

.GeneratePage-clear-button {
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  color: #7c867e;
  background: #f5f7f5;
  border: 1px solid #e2e8e3;
  border-radius: 7px;
  font-size: 11px;
}

.GeneratePage-clear-button:hover {
  color: var(--canvas-ink, #171a17);
  background: #eef3ed;
}

.GeneratePage-current-result {
  display: flex;
  min-width: 0;
  min-height: 220px;
  flex: 0 0 auto;
  flex-direction: column;
  justify-content: center;
  overflow-y: auto;
  scrollbar-width: thin;
}

.GeneratePage-empty-state {
  display: flex;
  min-height: 220px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
}

.GeneratePage-empty-mark,
.GeneratePage-processing-mark,
.GeneratePage-error-mark {
  display: grid;
  place-items: center;
  color: #739c52;
  background: #edf6e7;
  border-radius: 12px;
}

.GeneratePage-empty-mark {
  width: 58px;
  height: 58px;
  margin-bottom: 18px;
  font-size: 24px;
}

.GeneratePage-empty-state h3,
.GeneratePage-processing-state h3,
.GeneratePage-error-state h3 {
  margin: 0;
  color: var(--canvas-ink, #171a17);
  font-size: 15px;
  font-weight: 720;
}

.GeneratePage-empty-state p,
.GeneratePage-processing-state p,
.GeneratePage-error-state p {
  max-width: 360px;
  margin: 8px 0 0;
  color: var(--canvas-muted, #737b75);
  font-size: 11px;
  line-height: 1.55;
}

.GeneratePage-empty-state.is-completed .GeneratePage-empty-mark {
  color: #4e852e;
  background: #e9f5df;
}

.GeneratePage-processing-state {
  min-height: 220px;
  padding: 28px 8px 8px;
}

.GeneratePage-processing-copy {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 13px;
  text-align: left;
}

.GeneratePage-processing-mark {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  font-size: 16px;
  animation: GeneratePage-pulse 1.5s ease-in-out infinite;
}

.GeneratePage-skeleton-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
  width: 100%;
  max-width: 520px;
  margin: 24px auto 0;
}

.GeneratePage-skeleton-grid span {
  display: block;
  aspect-ratio: 4 / 3;
  background: linear-gradient(110deg, #eef2ee 20%, #f8faf8 38%, #eef2ee 56%);
  background-size: 220% 100%;
  border-radius: 10px;
  animation: GeneratePage-shimmer 1.45s linear infinite;
}

.GeneratePage-media-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding-top: 18px;
}

.GeneratePage-current-result .GeneratePage-media-grid {
  max-height: 320px;
  overflow-y: auto;
  padding-right: 2px;
  scrollbar-width: thin;
}

.GeneratePage-media-result {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  background: #f2f4f2;
  border-radius: 10px;
}

.GeneratePage-media-result img,
.GeneratePage-media-result video {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  background: #e9eeeb;
}

.GeneratePage-media-result.is-video video {
  aspect-ratio: 16 / 9;
  object-fit: contain;
  background: #151814;
}

.GeneratePage-media-result figcaption {
  display: flex;
  min-height: 38px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 10px;
  color: #78837b;
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 9px;
}

.GeneratePage-media-result figcaption a {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #4c7535;
  font-family: inherit;
  font-size: 9px;
  text-decoration: none;
}

.GeneratePage-media-result figcaption a:hover {
  color: #263d1c;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.GeneratePage-error-state {
  display: flex;
  min-height: 220px;
  align-items: center;
  justify-content: center;
  gap: 13px;
  padding: 32px;
  text-align: left;
}

.GeneratePage-error-mark {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  color: #b65745;
  background: #fff0e8;
  font-size: 17px;
}

.GeneratePage-error-state button {
  flex: 0 0 auto;
  min-height: 34px;
  padding: 7px 11px;
  color: #3f6530;
  background: #eef7e7;
  border: 1px solid #cee4bd;
  border-radius: 7px;
  font-size: 10px;
  font-weight: 700;
}

.GeneratePage-error-state button:hover {
  background: #e2f1d7;
}

.GeneratePage-history {
  display: flex;
  min-width: 0;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #edf0ee;
}

.GeneratePage-history-header {
  display: flex;
  flex: 0 0 auto;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 9px;
}

.GeneratePage-history-header h3 {
  margin: 0;
  color: var(--canvas-ink, #171a17);
  font-size: 12px;
  font-weight: 720;
  line-height: 1.3;
}

.GeneratePage-history-header p {
  margin: 3px 0 0;
  color: var(--canvas-muted, #737b75);
  font-size: 9px;
  line-height: 1.4;
}

.GeneratePage-history-count {
  flex: 0 0 auto;
  padding-top: 1px;
  color: #809083;
  font-size: 9px;
  font-variant-numeric: tabular-nums;
}

.GeneratePage-history-list {
  display: grid;
  min-height: 0;
  flex: 1 1 auto;
  gap: 7px;
  overflow-y: auto;
  padding: 1px 3px 2px 0;
  scrollbar-width: thin;
}

.GeneratePage-history-item {
  display: grid;
  grid-template-columns: 70px minmax(0, 1fr);
  align-items: stretch;
  gap: 9px;
  min-width: 0;
  min-height: 70px;
  padding: 7px;
  background: #fbfcfb;
  border: 1px solid #e5ebe6;
  border-radius: 8px;
}

.GeneratePage-history-thumb {
  display: grid;
  width: 70px;
  height: 56px;
  place-items: center;
  overflow: hidden;
  color: #72965d;
  background: #edf4e9;
  border-radius: 6px;
  font-size: 15px;
}

.GeneratePage-history-thumb img,
.GeneratePage-history-thumb video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #e9eeeb;
}

.GeneratePage-history-thumb.is-video video {
  object-fit: contain;
  background: #171b17;
}

.GeneratePage-history-thumb.is-audio {
  color: #a06a35;
  background: #fff2df;
}

.GeneratePage-history-thumb.is-empty {
  color: #8a958d;
  background: #f0f3f0;
}

.GeneratePage-history-item-body {
  display: flex;
  min-width: 0;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
}

.GeneratePage-history-item-header,
.GeneratePage-history-item-footer {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.GeneratePage-history-item-header strong {
  min-width: 0;
  overflow: hidden;
  color: #36443a;
  font-size: 10px;
  font-weight: 720;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.GeneratePage-history-status {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 4px;
  font-size: 8px;
  font-weight: 700;
  white-space: nowrap;
}

.GeneratePage-history-status i {
  width: 4px;
  height: 4px;
  background: currentColor;
  border-radius: 50%;
}

.GeneratePage-history-status.is-processing {
  color: #9a6a1e;
}

.GeneratePage-history-status.is-completed {
  color: #4c7a2f;
}

.GeneratePage-history-status.is-failed {
  color: #b55249;
}

.GeneratePage-history-item-body p {
  display: -webkit-box;
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: #69746c;
  font-size: 9px;
  line-height: 1.4;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.GeneratePage-history-item-footer {
  color: #8a958d;
  font-size: 8px;
  font-variant-numeric: tabular-nums;
}

.GeneratePage-history-item-footer span {
  color: #6e846a;
}

.GeneratePage-history-state {
  display: flex;
  min-height: 82px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 8px;
  color: #7e8980;
  font-size: 9px;
  text-align: center;
}

.GeneratePage-history-state > i {
  color: #779b5c;
  font-size: 13px;
}

.GeneratePage-history-state.is-error {
  color: #ad5b4c;
}

.GeneratePage-history-login,
.GeneratePage-history-retry {
  min-height: 26px;
  padding: 4px 8px;
  color: #3f6530;
  background: #eef7e7;
  border: 1px solid #cee4bd;
  border-radius: 6px;
  font-size: 9px;
  font-weight: 700;
}

.GeneratePage-history-login:hover,
.GeneratePage-history-retry:hover {
  background: #e2f1d7;
}

.GeneratePage-history-inline-error {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-top: 6px;
  color: #ad5b4c;
  font-size: 8px;
}

.GeneratePage-history-load-more {
  display: inline-flex;
  min-height: 28px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 7px;
  color: #5e7c52;
  background: #f5f8f3;
  border: 1px solid #dce9d5;
  border-radius: 7px;
  font-size: 9px;
  font-weight: 700;
}

.GeneratePage-history-load-more:hover:not(:disabled) {
  color: #36512d;
  background: #edf6e8;
  border-color: #c7dbbd;
}

.GeneratePage-history-load-more:disabled {
  cursor: wait;
  opacity: 0.6;
}

.GeneratePage-current-result::-webkit-scrollbar,
.GeneratePage-current-result .GeneratePage-media-grid::-webkit-scrollbar,
.GeneratePage-history-list::-webkit-scrollbar {
  width: 7px;
}

.GeneratePage-current-result::-webkit-scrollbar-thumb,
.GeneratePage-current-result .GeneratePage-media-grid::-webkit-scrollbar-thumb,
.GeneratePage-history-list::-webkit-scrollbar-thumb {
  background: #cbd8c9;
  border-radius: 999px;
}

.GeneratePage-current-result::-webkit-scrollbar-track,
.GeneratePage-current-result .GeneratePage-media-grid::-webkit-scrollbar-track,
.GeneratePage-history-list::-webkit-scrollbar-track {
  background: transparent;
}

@keyframes GeneratePage-pulse {
  50% { transform: scale(0.92); opacity: 0.65; }
}

@keyframes GeneratePage-shimmer {
  to { background-position: -220% 0; }
}

@keyframes GeneratePage-spin {
  to { transform: rotate(360deg); }
}

@keyframes GeneratePage-menu-enter {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (min-width: 901px) and (max-height: 800px) {
  .GeneratePage-main {
    padding-top: 12px;
    padding-bottom: 18px;
  }

  .GeneratePage-header {
    min-height: 34px;
    padding-bottom: 10px;
  }

  .GeneratePage-header h1 {
    font-size: 25px;
  }

  .GeneratePage-workspace {
    gap: 16px;
    padding-top: 12px;
  }

  .GeneratePage-controls {
    padding: 9px 14px 8px;
  }

  .GeneratePage-section {
    margin-bottom: 6px;
    padding-bottom: 6px;
  }

  .GeneratePage-section-heading {
    margin-bottom: 4px;
  }

  .GeneratePage-section-heading h2 {
    font-size: 14px;
  }

  .GeneratePage-section-heading p {
    font-size: 9px;
  }

  .GeneratePage-reference-section .GeneratePage-section-heading {
    margin-bottom: 4px;
  }

  .GeneratePage-reference-section .GeneratePage-section-heading p {
    max-width: 220px;
    font-size: 8px;
  }

  .GeneratePage-reference-add {
    min-height: 28px;
    padding: 4px 6px;
    font-size: 8px;
  }

  .GeneratePage-reference-add > i {
    font-size: 10px;
  }

  .GeneratePage-reference-add small,
  .GeneratePage-reference-meta,
  .GeneratePage-reference-notice,
  .GeneratePage-reference-error {
    font-size: 7px;
  }

  .GeneratePage-reference-list {
    max-height: 84px;
  }

  .GeneratePage-params-toggle {
    grid-template-columns: 25px minmax(0, 1fr) auto;
    min-height: 32px;
  }

  .GeneratePage-params-toggle-mark {
    width: 25px;
    height: 25px;
    font-size: 11px;
  }

  .GeneratePage-params-toggle-copy strong {
    font-size: 10px;
  }

  .GeneratePage-params-toggle-copy small,
  .GeneratePage-params-toggle-action em {
    font-size: 7px;
  }

  .GeneratePage-params-panel {
    padding-top: 5px;
  }

  .GeneratePage-model-tabs {
    gap: 5px;
    margin-bottom: 5px;
  }

  .GeneratePage-model-tab {
    min-height: 26px;
    padding: 4px 7px;
    font-size: 9px;
  }

  .GeneratePage-model-picker-trigger {
    grid-template-columns: 28px minmax(0, 1fr) auto;
    gap: 7px;
    min-height: 44px;
    padding: 7px 8px;
  }

  .GeneratePage-model-mark {
    width: 25px;
    height: 25px;
    font-size: 12px;
  }

  .GeneratePage-model-picker-copy {
    gap: 2px;
  }

  .GeneratePage-model-picker-copy strong {
    font-size: 11px;
  }

  .GeneratePage-model-picker-copy small {
    font-size: 8px;
  }

  .GeneratePage-prompt-field textarea {
    height: 70px;
    min-height: 70px;
    max-height: 70px;
    padding: 8px 9px 24px;
    font-size: 10px;
  }

  .GeneratePage-field-grid {
    gap: 6px;
  }

  .GeneratePage-option-field {
    gap: 3px;
  }

  .GeneratePage-option-field > span,
  .GeneratePage-choice-field legend {
    font-size: 8px;
  }

  .GeneratePage-option-trigger {
    min-height: 30px;
    padding: 0 8px;
    font-size: 9px;
  }

  .GeneratePage-choice-field {
    margin-top: 7px;
  }

  .GeneratePage-quality-options {
    gap: 4px;
  }

  .GeneratePage-quality-options button {
    min-height: 32px;
    gap: 1px;
    padding: 4px 6px;
  }

  .GeneratePage-quality-options strong {
    font-size: 8px;
  }

  .GeneratePage-quality-options small {
    font-size: 7px;
  }

  .GeneratePage-audio-toggle {
    min-height: 24px;
    margin-top: 6px;
    font-size: 8px;
  }

  .GeneratePage-parameter-note {
    gap: 5px;
    margin-top: 4px;
    font-size: 8px;
  }

  .GeneratePage-submit-area {
    gap: 6px;
  }

  .GeneratePage-quote {
    min-height: 31px;
    padding: 4px 7px;
  }

  .GeneratePage-quote-icon {
    width: 20px;
    height: 20px;
    flex-basis: 20px;
    font-size: 10px;
  }

  .GeneratePage-quote strong {
    font-size: 8px;
  }

  .GeneratePage-quote small {
    font-size: 7px;
  }

  .GeneratePage-submit {
    min-height: 34px;
    font-size: 10px;
  }
}

@media (max-width: 1080px) {
  .GeneratePage-main { padding-right: 24px; padding-left: 24px; }
  .GeneratePage-workspace { grid-template-columns: minmax(300px, 350px) minmax(0, 1fr); gap: 18px; }
  .GeneratePage-controls,
  .GeneratePage-results { padding-right: 18px; padding-left: 18px; }
}

@media (max-width: 900px) {
  .GeneratePage-workspace { grid-template-columns: 1fr; }
  .GeneratePage-controls { position: static; }
  .GeneratePage-results {
    height: auto;
    min-height: 520px;
    max-height: none;
    overflow: visible;
  }
  .GeneratePage-current-result {
    max-height: none;
    overflow: visible;
  }
  .GeneratePage-history-list {
    max-height: 280px;
    flex: 0 1 280px;
  }
}

@media (max-width: 720px) {
  .GeneratePage-root { margin-left: 68px; }
  .GeneratePage-main { padding: 14px 10px 28px; }
  .GeneratePage-header { align-items: flex-start; flex-direction: column; gap: 8px; padding-bottom: 12px; }
  .GeneratePage-header h1 { font-size: 24px; }
  .GeneratePage-workspace { padding-top: 12px; }
  .GeneratePage-controls,
  .GeneratePage-results { border-radius: 11px; }
  .GeneratePage-controls { padding: 12px 12px 10px; }
  .GeneratePage-results { padding: 16px; }
  .GeneratePage-section { margin-bottom: 10px; padding-bottom: 10px; }
  .GeneratePage-section-heading { margin-bottom: 7px; }
  .GeneratePage-prompt-field textarea {
    height: 88px;
    min-height: 88px;
    max-height: 88px;
  }
  .GeneratePage-empty-state,
  .GeneratePage-processing-state { min-height: 260px; }
  .GeneratePage-media-grid { grid-template-columns: 1fr; }
  .GeneratePage-error-state { align-items: flex-start; flex-wrap: wrap; justify-content: flex-start; padding: 28px 8px; }
  .GeneratePage-error-state button { margin-left: 55px; }
}

@media (max-width: 440px) {
  .GeneratePage-field-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .GeneratePage-quality-options { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .GeneratePage-quality-options button {
    min-height: 42px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
  .GeneratePage-model-copy small { white-space: normal; }
  .GeneratePage-results-header { flex-direction: column; }
  .GeneratePage-result-actions { align-self: flex-start; }
}

@media (prefers-reduced-motion: reduce) {
  .GeneratePage-model-option,
  .GeneratePage-model-tab,
  .GeneratePage-model-picker-trigger,
  .GeneratePage-option-trigger,
  .GeneratePage-submit,
  .GeneratePage-prompt-field textarea { transition: none; }
  .GeneratePage-quote.is-loading .GeneratePage-quote-icon,
  .GeneratePage-processing-mark,
  .GeneratePage-skeleton-grid span,
  .GeneratePage-spin,
  .GeneratePage-model-menu,
  .GeneratePage-option-list,
  .GeneratePage-params-panel { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/generate/GeneratePage.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,oDAAoD;AACtD;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,kBAAkB;EAClB,SAAS;EACT,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,mCAAmC;EACnC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gGAAgG;EAChG,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4EAA4E;AAC9E;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iFAAiF;AACnF;;AAEA;;EAEE,mBAAmB;EACnB,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,qCAAqC;EACrC,oDAAoD;EACpD,mBAAmB;EACnB,8CAA8C;EAC9C,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+CAA+C;EAC/C,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iFAAiF;AACnF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,4DAA4D;EAC5D,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;;;;;;;;;;;;;;;;;EAiBE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;;;;;;EAME,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,6DAA6D;EAC7D,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,iFAAiF;AACnF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,4EAA4E;AAC9E;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAS;AACX;;AAEA;;EAEE,UAAU;EACV,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,cAAc;EACd,iCAAiC;EACjC,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iFAAiF;AACnF;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,QAAQ;EACR,OAAO;EACP,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,oDAAoD;EACpD,kBAAkB;EAClB,8CAA8C;EAC9C,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,iCAAiC;EACjC,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,sCAAsC;EACtC,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kGAAkG;AACpG;;AAEA;EACE,iCAAiC;EACjC,6CAA6C;EAC7C,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;EAGE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,0EAA0E;EAC1E,0BAA0B;EAC1B,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,QAAQ;EACR,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,MAAM,sBAAsB,EAAE,aAAa,EAAE;AAC/C;;AAEA;EACE,KAAK,4BAA4B,EAAE;AACrC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,+CAA+C;IAC/C,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,+CAA+C;IAC/C,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,QAAQ;IACR,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,qBAAqB,mBAAmB,EAAE,kBAAkB,EAAE;EAC9D,0BAA0B,0DAA0D,EAAE,SAAS,EAAE;EACjG;0BACwB,mBAAmB,EAAE,kBAAkB,EAAE;AACnE;;AAEA;EACE,0BAA0B,0BAA0B,EAAE;EACtD,yBAAyB,gBAAgB,EAAE;EAC3C;IACE,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE,qBAAqB,iBAAiB,EAAE;EACxC,qBAAqB,uBAAuB,EAAE;EAC9C,uBAAuB,uBAAuB,EAAE,sBAAsB,EAAE,QAAQ,EAAE,oBAAoB,EAAE;EACxG,0BAA0B,eAAe,EAAE;EAC3C,0BAA0B,iBAAiB,EAAE;EAC7C;0BACwB,mBAAmB,EAAE;EAC7C,yBAAyB,uBAAuB,EAAE;EAClD,wBAAwB,aAAa,EAAE;EACvC,wBAAwB,mBAAmB,EAAE,oBAAoB,EAAE;EACnE,gCAAgC,kBAAkB,EAAE;EACpD;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;EACA;mCACiC,iBAAiB,EAAE;EACpD,2BAA2B,0BAA0B,EAAE;EACvD,4BAA4B,uBAAuB,EAAE,eAAe,EAAE,2BAA2B,EAAE,iBAAiB,EAAE;EACtH,mCAAmC,iBAAiB,EAAE;AACxD;;AAEA;EACE,2BAA2B,gDAAgD,EAAE;EAC7E,gCAAgC,gDAAgD,EAAE;EAClF;IACE,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;EACzB;EACA,iCAAiC,mBAAmB,EAAE;EACtD,+BAA+B,sBAAsB,EAAE;EACvD,+BAA+B,sBAAsB,EAAE;AACzD;;AAEA;EACE;;;;;wCAKsC,gBAAgB,EAAE;EACxD;;;;;;+BAM6B,eAAe,EAAE;AAChD","sourcesContent":[".GeneratePage-root {\n  min-height: calc(100vh - 60px);\n  margin-left: 88px;\n  color: var(--canvas-ink, #171a17);\n  background: #f3f5f6;\n}\n\n.GeneratePage-root .sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.GeneratePage-main {\n  width: min(1540px, 100%);\n  margin: 0 auto;\n  padding: 18px 30px 34px;\n}\n\n.GeneratePage-header {\n  display: flex;\n  min-height: 46px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 28px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid var(--canvas-line, #e2e6e4);\n}\n\n.GeneratePage-header h1 {\n  margin: 0;\n  color: var(--canvas-ink, #171a17);\n  font-size: 28px;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n  line-height: 1.12;\n}\n\n.GeneratePage-header p {\n  margin: 9px 0 0;\n  color: var(--canvas-muted, #737b75);\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.GeneratePage-workspace {\n  display: grid;\n  grid-template-columns: minmax(330px, 390px) minmax(0, 1fr);\n  align-items: start;\n  gap: 20px;\n  padding-top: 16px;\n}\n\n.GeneratePage-controls,\n.GeneratePage-results {\n  min-width: 0;\n  background: #fff;\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 14px;\n}\n\n.GeneratePage-controls {\n  position: sticky;\n  top: 76px;\n  padding: 16px 18px 15px;\n}\n\n.GeneratePage-section {\n  margin-bottom: 14px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid #edf0ee;\n}\n\n.GeneratePage-section-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  margin-bottom: 9px;\n}\n\n.GeneratePage-section-heading h2,\n.GeneratePage-results-header h2 {\n  margin: 0;\n  color: var(--canvas-ink, #171a17);\n  font-size: 15px;\n  font-weight: 720;\n  letter-spacing: -0.01em;\n  line-height: 1.3;\n}\n\n.GeneratePage-section-heading p,\n.GeneratePage-results-header p {\n  margin: 3px 0 0;\n  color: var(--canvas-muted, #737b75);\n  font-size: 10px;\n  line-height: 1.45;\n}\n\n.GeneratePage-result-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 3px 9px;\n}\n\n.GeneratePage-task-id {\n  overflow-wrap: anywhere;\n  color: #66746a;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", monospace;\n  font-size: 9px;\n}\n\n.GeneratePage-section-count,\n.GeneratePage-required {\n  flex: 0 0 auto;\n  color: #6f7971;\n  font-size: 10px;\n  line-height: 1.4;\n}\n\n.GeneratePage-required {\n  color: #b65a42;\n}\n\n.GeneratePage-model-tabs {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.GeneratePage-model-tab {\n  display: flex;\n  min-height: 31px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 5px 8px;\n  color: #758078;\n  background: #f7f9f7;\n  border: 1px solid #e5ebe6;\n  border-radius: 7px;\n  font-size: 10px;\n  font-weight: 700;\n  transition: color 160ms ease, background 160ms ease, border-color 160ms ease;\n}\n\n.GeneratePage-model-tab small {\n  min-width: 16px;\n  padding: 2px 4px;\n  color: #849087;\n  background: #e9eeea;\n  border-radius: 4px;\n  font-size: 8px;\n  line-height: 1;\n}\n\n.GeneratePage-model-tab:hover:not(:disabled) {\n  color: #36512d;\n  border-color: #c7dbbd;\n}\n\n.GeneratePage-model-tab.is-selected {\n  color: #315327;\n  background: #eaf5df;\n  border-color: #b9df8a;\n}\n\n.GeneratePage-model-tab.is-selected small {\n  color: #4b7335;\n  background: #d8edc2;\n}\n\n.GeneratePage-model-picker {\n  position: relative;\n}\n\n.GeneratePage-model-picker-trigger {\n  display: grid;\n  grid-template-columns: 32px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 9px;\n  width: 100%;\n  min-height: 60px;\n  padding: 9px 10px;\n  color: var(--canvas-ink, #171a17);\n  background: #fbfcfb;\n  border: 1px solid #d7e1d9;\n  border-radius: 9px;\n  text-align: left;\n  transition: border-color 160ms ease, background 160ms ease, box-shadow 160ms ease;\n}\n\n.GeneratePage-model-picker-trigger:hover:not(:disabled),\n.GeneratePage-model-picker-trigger.is-open {\n  background: #f7faf6;\n  border-color: var(--model-accent, #70a33d);\n  box-shadow: 0 4px 12px rgba(24, 30, 26, 0.06);\n}\n\n.GeneratePage-model-picker-copy {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.GeneratePage-model-picker-copy strong {\n  overflow: hidden;\n  font-size: 12px;\n  font-weight: 720;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.GeneratePage-model-picker-copy small {\n  overflow: hidden;\n  color: var(--canvas-muted, #737b75);\n  font-size: 9px;\n  line-height: 1.35;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.GeneratePage-model-picker-action {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #6c776f;\n  font-size: 9px;\n  font-weight: 700;\n}\n\n.GeneratePage-model-picker-trigger.is-open .GeneratePage-model-picker-action i {\n  transform: rotate(180deg);\n}\n\n.GeneratePage-model-picker-action i {\n  transition: transform 160ms ease;\n}\n\n.GeneratePage-model-menu {\n  position: absolute;\n  z-index: 30;\n  top: calc(100% + 7px);\n  right: 0;\n  left: 0;\n  padding: 7px;\n  background: rgba(255, 255, 255, 0.99);\n  border: 1px solid var(--canvas-line-strong, #ccd2ce);\n  border-radius: 10px;\n  box-shadow: 0 16px 36px rgba(24, 30, 26, 0.14);\n  animation: GeneratePage-menu-enter 130ms ease-out;\n}\n\n.GeneratePage-model-menu-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 3px 5px 7px;\n  color: #4d5a50;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.GeneratePage-model-menu-header small {\n  color: #88928b;\n  font-size: 9px;\n  font-weight: 500;\n}\n\n.GeneratePage-model-menu-list {\n  display: grid;\n  gap: 5px;\n  max-height: min(360px, calc(100vh - 180px));\n  overflow-y: auto;\n  padding-right: 1px;\n  scrollbar-width: thin;\n}\n\n.GeneratePage-model-option {\n  position: relative;\n  display: grid;\n  grid-template-columns: 32px minmax(0, 1fr) 15px;\n  align-items: start;\n  gap: 8px;\n  width: 100%;\n  min-height: 57px;\n  padding: 9px;\n  color: var(--canvas-ink, #171a17);\n  background: #fbfcfb;\n  border: 1px solid #e4e9e5;\n  border-radius: 8px;\n  text-align: left;\n  transition: border-color 160ms ease, background 160ms ease, box-shadow 160ms ease;\n}\n\n.GeneratePage-model-option:hover:not(:disabled) {\n  background: #f5f8f3;\n  border-color: #c3d9b5;\n}\n\n.GeneratePage-model-option.is-selected {\n  background: color-mix(in srgb, var(--model-accent) 7%, #fff);\n  border-color: var(--model-accent);\n  box-shadow: 0 5px 14px rgba(24, 30, 26, 0.06);\n}\n\n.GeneratePage-model-option:focus-visible,\n.GeneratePage-model-picker-trigger:focus-visible,\n.GeneratePage-model-tab:focus-visible,\n.GeneratePage-option-trigger:focus-visible,\n.GeneratePage-option-list button:focus-visible,\n.GeneratePage-params-toggle:focus-visible,\n.GeneratePage-quality-options button:focus-visible,\n.GeneratePage-reference-add:focus-visible,\n.GeneratePage-reference-remove:focus-visible,\n.GeneratePage-audio-toggle:focus-within,\n.GeneratePage-submit:focus-visible,\n.GeneratePage-clear-button:focus-visible,\n.GeneratePage-error-state button:focus-visible,\n.GeneratePage-history-login:focus-visible,\n.GeneratePage-history-retry:focus-visible,\n.GeneratePage-history-load-more:focus-visible,\n.GeneratePage-media-result figcaption a:focus-visible {\n  outline: 2px solid var(--canvas-green-strong, #70a33d);\n  outline-offset: 2px;\n}\n\n.GeneratePage-model-option:disabled,\n.GeneratePage-model-tab:disabled,\n.GeneratePage-model-picker-trigger:disabled,\n.GeneratePage-option-trigger:disabled,\n.GeneratePage-quality-options button:disabled,\n.GeneratePage-submit:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.GeneratePage-model-mark {\n  display: grid;\n  width: 32px;\n  height: 32px;\n  place-items: center;\n  color: var(--model-accent);\n  background: color-mix(in srgb, var(--model-accent) 11%, #fff);\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.GeneratePage-model-copy {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.GeneratePage-model-copy strong {\n  font-size: 11px;\n  font-weight: 720;\n  line-height: 1.3;\n}\n\n.GeneratePage-model-copy small {\n  overflow: hidden;\n  color: var(--canvas-muted, #737b75);\n  font-size: 9px;\n  line-height: 1.4;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.GeneratePage-model-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 1px;\n}\n\n.GeneratePage-model-tags em {\n  padding: 2px 4px;\n  color: #6a746d;\n  background: #eef1ee;\n  border-radius: 4px;\n  font-size: 7px;\n  font-style: normal;\n  line-height: 1;\n}\n\n.GeneratePage-model-check {\n  padding-top: 2px;\n  color: var(--model-accent);\n  font-size: 14px;\n  opacity: 0;\n}\n\n.GeneratePage-model-option.is-selected .GeneratePage-model-check {\n  opacity: 1;\n}\n\n.GeneratePage-prompt-field {\n  position: relative;\n  display: block;\n}\n\n.GeneratePage-prompt-field textarea {\n  display: block;\n  width: 100%;\n  height: 104px;\n  min-height: 104px;\n  max-height: 104px;\n  resize: none;\n  padding: 10px 11px 27px;\n  color: var(--canvas-ink, #171a17);\n  background: #fbfcfb;\n  border: 1px solid #dfe5e1;\n  border-radius: 9px;\n  font-size: 11px;\n  line-height: 1.55;\n  outline: none;\n  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;\n}\n\n.GeneratePage-prompt-field textarea::placeholder {\n  color: #8b938d;\n}\n\n.GeneratePage-prompt-field textarea:hover:not(:disabled) {\n  border-color: #bfcac1;\n}\n\n.GeneratePage-prompt-field textarea:focus {\n  background: #fff;\n  border-color: var(--canvas-green-strong, #70a33d);\n  box-shadow: 0 0 0 3px rgba(112, 163, 61, 0.13);\n}\n\n.GeneratePage-prompt-field textarea:disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.GeneratePage-prompt-count {\n  position: absolute;\n  right: 11px;\n  bottom: 10px;\n  color: #909991;\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 9px;\n}\n\n.GeneratePage-reference-section .GeneratePage-section-heading {\n  margin-bottom: 6px;\n}\n\n.GeneratePage-reference-section .GeneratePage-section-heading p {\n  max-width: 270px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.GeneratePage-reference-actions {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(88px, 1fr));\n  gap: 5px;\n}\n\n.GeneratePage-reference-action {\n  min-width: 0;\n}\n\n.GeneratePage-reference-add {\n  display: flex;\n  min-height: 31px;\n  align-items: center;\n  gap: 5px;\n  width: 100%;\n  padding: 5px 7px;\n  color: #5f6d63;\n  background: #fbfcfb;\n  border: 1px solid #dfe7e0;\n  border-radius: 7px;\n  font-size: 9px;\n  font-weight: 680;\n  text-align: left;\n  transition: color 160ms ease, background 160ms ease, border-color 160ms ease;\n}\n\n.GeneratePage-reference-add > i {\n  flex: 0 0 auto;\n  color: #6d9a52;\n  font-size: 11px;\n}\n\n.GeneratePage-reference-add span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.GeneratePage-reference-add small {\n  margin-left: auto;\n  color: #8a958d;\n  font-size: 8px;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.GeneratePage-reference-add:hover:not(:disabled) {\n  color: #36512d;\n  background: #f0f7eb;\n  border-color: #bcd7ac;\n}\n\n.GeneratePage-reference-add:disabled {\n  cursor: not-allowed;\n  opacity: 0.52;\n}\n\n.GeneratePage-reference-input {\n  display: none;\n}\n\n.GeneratePage-reference-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 5px;\n  color: #8a958d;\n  font-size: 8px;\n  line-height: 1.35;\n}\n\n.GeneratePage-reference-meta span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.GeneratePage-reference-meta span:first-child {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.GeneratePage-reference-meta i {\n  color: #6c9953;\n}\n\n.GeneratePage-reference-notice,\n.GeneratePage-reference-error {\n  display: flex;\n  align-items: flex-start;\n  gap: 5px;\n  margin-top: 5px;\n  font-size: 8px;\n  line-height: 1.4;\n}\n\n.GeneratePage-reference-notice {\n  color: #8b6c2e;\n}\n\n.GeneratePage-reference-error {\n  color: #ae5a4c;\n}\n\n.GeneratePage-reference-notice i,\n.GeneratePage-reference-error i {\n  flex: 0 0 auto;\n  padding-top: 1px;\n}\n\n.GeneratePage-reference-list {\n  display: grid;\n  max-height: 112px;\n  gap: 4px;\n  margin-top: 6px;\n  overflow-y: auto;\n  padding-right: 2px;\n  scrollbar-width: thin;\n}\n\n.GeneratePage-reference-item {\n  display: grid;\n  grid-template-columns: 34px minmax(0, 1fr) 22px;\n  align-items: center;\n  gap: 7px;\n  min-width: 0;\n  min-height: 36px;\n  padding: 3px 4px;\n  background: #f7faf6;\n  border: 1px solid #e4ece2;\n  border-radius: 6px;\n}\n\n.GeneratePage-reference-preview {\n  position: relative;\n  display: grid;\n  width: 34px;\n  height: 28px;\n  place-items: center;\n  overflow: hidden;\n  color: #779b5f;\n  background: #eaf3e5;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.GeneratePage-reference-item.is-video .GeneratePage-reference-preview {\n  color: #7a6b91;\n  background: #f0ecf6;\n}\n\n.GeneratePage-reference-item.is-audio .GeneratePage-reference-preview {\n  color: #a06a35;\n  background: #fff1df;\n}\n\n.GeneratePage-reference-preview img,\n.GeneratePage-reference-preview video {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.GeneratePage-reference-preview video {\n  background: #171b17;\n  object-fit: contain;\n}\n\n.GeneratePage-reference-uploading,\n.GeneratePage-reference-ready {\n  position: absolute;\n  right: 2px;\n  bottom: 2px;\n  display: grid;\n  min-width: 12px;\n  height: 12px;\n  place-items: center;\n  padding: 0 2px;\n  color: #fff;\n  background: #5b8250;\n  border-radius: 3px;\n  font-size: 7px;\n  line-height: 1;\n}\n\n.GeneratePage-reference-uploading {\n  background: #9a6a1e;\n}\n\n.GeneratePage-reference-copy {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.GeneratePage-reference-copy strong,\n.GeneratePage-reference-copy small {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.GeneratePage-reference-copy strong {\n  color: #465749;\n  font-size: 9px;\n  font-weight: 700;\n}\n\n.GeneratePage-reference-copy small {\n  color: #8a958d;\n  font-size: 8px;\n}\n\n.GeneratePage-reference-remove {\n  display: grid;\n  width: 22px;\n  height: 22px;\n  place-items: center;\n  color: #8a958d;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 5px;\n  font-size: 9px;\n}\n\n.GeneratePage-reference-remove:hover:not(:disabled) {\n  color: #a84f45;\n  background: #fff0ed;\n  border-color: #f0d0ca;\n}\n\n.GeneratePage-reference-remove:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.GeneratePage-reference-list::-webkit-scrollbar {\n  width: 5px;\n}\n\n.GeneratePage-reference-list::-webkit-scrollbar-thumb {\n  background: #cbd8c9;\n  border-radius: 999px;\n}\n\n.GeneratePage-field-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.GeneratePage-option-field,\n.GeneratePage-choice-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n  margin: 0;\n}\n\n.GeneratePage-option-field > span,\n.GeneratePage-choice-field legend {\n  padding: 0;\n  color: #5f6961;\n  font-size: 9px;\n  font-weight: 650;\n}\n\n.GeneratePage-option-menu {\n  position: relative;\n  min-width: 0;\n}\n\n.GeneratePage-option-trigger {\n  display: flex;\n  min-height: 35px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 7px;\n  width: 100%;\n  padding: 0 9px;\n  color: var(--canvas-ink, #171a17);\n  background: #fbfcfb;\n  border: 1px solid #dfe5e1;\n  border-radius: 8px;\n  font-size: 10px;\n  outline: none;\n  text-align: left;\n  transition: border-color 160ms ease, background 160ms ease, box-shadow 160ms ease;\n}\n\n.GeneratePage-option-trigger:hover:not(:disabled),\n.GeneratePage-option-menu.is-open .GeneratePage-option-trigger {\n  background: #fff;\n  border-color: #b7c9b7;\n}\n\n.GeneratePage-option-trigger > span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.GeneratePage-option-trigger > i {\n  flex: 0 0 auto;\n  color: #77847b;\n  font-size: 10px;\n  transition: transform 160ms ease;\n}\n\n.GeneratePage-option-menu.is-open .GeneratePage-option-trigger > i {\n  transform: rotate(180deg);\n}\n\n.GeneratePage-option-list {\n  position: absolute;\n  z-index: 25;\n  top: calc(100% + 6px);\n  right: 0;\n  left: 0;\n  display: grid;\n  gap: 3px;\n  min-width: 150px;\n  max-height: 270px;\n  overflow-y: auto;\n  padding: 5px;\n  background: #fff;\n  border: 1px solid var(--canvas-line-strong, #ccd2ce);\n  border-radius: 8px;\n  box-shadow: 0 12px 28px rgba(24, 30, 26, 0.13);\n  animation: GeneratePage-menu-enter 130ms ease-out;\n}\n\n.GeneratePage-option-list button {\n  position: relative;\n  display: flex;\n  min-height: 31px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 6px 7px;\n  color: #5f6c63;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  font-size: 10px;\n  text-align: left;\n}\n\n.GeneratePage-option-list button:hover,\n.GeneratePage-option-list button.is-selected {\n  color: #315327;\n  background: #eef7e8;\n  border-color: #d4e8c8;\n}\n\n.GeneratePage-option-list button small {\n  margin-left: auto;\n  color: #8a958d;\n  font-size: 8px;\n}\n\n.GeneratePage-option-list button > i {\n  flex: 0 0 auto;\n  color: var(--canvas-green-strong, #70a33d);\n  font-size: 11px;\n}\n\n.GeneratePage-choice-field {\n  margin-top: 10px;\n}\n\n.GeneratePage-quality-options {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 5px;\n}\n\n.GeneratePage-quality-options button {\n  display: flex;\n  min-height: 43px;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 2px;\n  padding: 6px 7px;\n  color: #637066;\n  background: #fbfcfb;\n  border: 1px solid #dfe5e1;\n  border-radius: 7px;\n  text-align: left;\n}\n\n.GeneratePage-quality-options button:hover:not(:disabled) {\n  border-color: #bfcfb6;\n}\n\n.GeneratePage-quality-options button.is-selected {\n  color: #355227;\n  background: #eff8e8;\n  border-color: #abd07f;\n}\n\n.GeneratePage-quality-options strong {\n  font-size: 9px;\n  font-weight: 720;\n}\n\n.GeneratePage-quality-options small {\n  font-size: 8px;\n  line-height: 1.3;\n}\n\n.GeneratePage-audio-toggle {\n  display: inline-flex;\n  min-height: 28px;\n  align-items: center;\n  gap: 7px;\n  margin-top: 9px;\n  padding: 4px 6px;\n  color: #5e6d62;\n  border-radius: 6px;\n  font-size: 9px;\n  font-weight: 650;\n}\n\n.GeneratePage-audio-toggle input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n}\n\n.GeneratePage-toggle-track {\n  position: relative;\n  display: inline-flex;\n  width: 25px;\n  height: 15px;\n  align-items: center;\n  padding: 2px;\n  background: #cfd8d0;\n  border-radius: 999px;\n  transition: background 160ms ease;\n}\n\n.GeneratePage-toggle-track i {\n  display: block;\n  width: 11px;\n  height: 11px;\n  background: #fff;\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(24, 30, 26, 0.16);\n  transition: transform 160ms ease;\n}\n\n.GeneratePage-audio-toggle input:checked + .GeneratePage-toggle-track {\n  background: var(--canvas-green-strong, #70a33d);\n}\n\n.GeneratePage-audio-toggle input:checked + .GeneratePage-toggle-track i {\n  transform: translateX(10px);\n}\n\n.GeneratePage-audio-toggle input:disabled + .GeneratePage-toggle-track,\n.GeneratePage-audio-toggle:has(input:disabled) {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.GeneratePage-params-toggle {\n  display: grid;\n  grid-template-columns: 28px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  min-height: 38px;\n  padding: 0;\n  color: var(--canvas-ink, #171a17);\n  background: transparent;\n  border: 0;\n  text-align: left;\n}\n\n.GeneratePage-params-toggle:hover:not(:disabled) .GeneratePage-params-toggle-copy strong {\n  color: #36512d;\n}\n\n.GeneratePage-params-toggle:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.GeneratePage-params-toggle-mark {\n  display: grid;\n  width: 28px;\n  height: 28px;\n  place-items: center;\n  color: #668d4f;\n  background: #edf5e8;\n  border-radius: 7px;\n  font-size: 12px;\n}\n\n.GeneratePage-params-toggle-copy {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.GeneratePage-params-toggle-copy strong {\n  overflow: hidden;\n  color: var(--canvas-ink, #171a17);\n  font-size: 11px;\n  font-weight: 720;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  transition: color 160ms ease;\n}\n\n.GeneratePage-params-toggle-copy small {\n  overflow: hidden;\n  color: #7c887f;\n  font-size: 8px;\n  line-height: 1.35;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.GeneratePage-params-toggle-action {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #708071;\n}\n\n.GeneratePage-params-toggle-action em {\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 700;\n}\n\n.GeneratePage-params-toggle-action i {\n  font-size: 10px;\n  transition: transform 160ms ease;\n}\n\n.GeneratePage-params-section.is-open .GeneratePage-params-toggle-action i {\n  transform: rotate(180deg);\n}\n\n.GeneratePage-params-panel {\n  padding-top: 8px;\n  animation: GeneratePage-menu-enter 130ms ease-out;\n}\n\n.GeneratePage-parameter-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  margin-top: 9px;\n  color: #717d74;\n  font-size: 9px;\n  line-height: 1.45;\n}\n\n.GeneratePage-parameter-note i {\n  padding-top: 1px;\n  color: var(--canvas-green-strong, #70a33d);\n}\n\n.GeneratePage-submit-area {\n  display: grid;\n  gap: 8px;\n}\n\n.GeneratePage-quote {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 39px;\n  padding: 6px 8px;\n  color: #68736b;\n  background: #f7f9f7;\n  border: 1px solid #e7ece8;\n  border-radius: 8px;\n}\n\n.GeneratePage-quote-icon {\n  display: grid;\n  width: 23px;\n  height: 23px;\n  flex: 0 0 23px;\n  place-items: center;\n  color: #6a9e39;\n  background: #e6f2d8;\n  border-radius: 6px;\n  font-size: 11px;\n}\n\n.GeneratePage-quote > span:last-child {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.GeneratePage-quote strong {\n  color: #465749;\n  font-size: 9px;\n  font-weight: 700;\n}\n\n.GeneratePage-quote small {\n  color: #89938b;\n  font-size: 8px;\n}\n\n.GeneratePage-submit {\n  display: inline-flex;\n  min-height: 42px;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  width: 100%;\n  color: #fff;\n  background: var(--canvas-ink, #171a17);\n  border: 1px solid var(--canvas-ink, #171a17);\n  border-radius: 8px;\n  font-size: 11px;\n  font-weight: 720;\n  transition: color 160ms ease, background 160ms ease, border-color 160ms ease, transform 160ms ease;\n}\n\n.GeneratePage-submit:hover:not(:disabled) {\n  color: var(--canvas-ink, #171a17);\n  background: var(--canvas-green-soft, #e3f3cb);\n  border-color: var(--canvas-green, #b9df8a);\n  transform: translateY(-1px);\n}\n\n.GeneratePage-spin {\n  animation: GeneratePage-spin 0.9s linear infinite;\n}\n\n.GeneratePage-results {\n  display: flex;\n  height: clamp(560px, calc(100vh - 104px), 720px);\n  min-height: 560px;\n  max-height: 720px;\n  flex-direction: column;\n  padding: 18px;\n  overflow: hidden;\n}\n\n.GeneratePage-results-header {\n  display: flex;\n  flex: 0 0 auto;\n  min-height: 46px;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding-bottom: 17px;\n  border-bottom: 1px solid #edf0ee;\n}\n\n.GeneratePage-result-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n}\n\n.GeneratePage-status {\n  display: inline-flex;\n  height: 24px;\n  align-items: center;\n  gap: 6px;\n  padding: 0 9px;\n  border-radius: 999px;\n  font-size: 9px;\n  font-weight: 700;\n}\n\n.GeneratePage-status i {\n  width: 5px;\n  height: 5px;\n  background: currentColor;\n  border-radius: 50%;\n}\n\n.GeneratePage-status.is-pending,\n.GeneratePage-status.is-processing {\n  color: #9a6a1e;\n  background: #fff6df;\n}\n\n.GeneratePage-status.is-completed {\n  color: #4c7a2f;\n  background: #e9f5df;\n}\n\n.GeneratePage-status.is-failed {\n  color: #b55249;\n  background: #fbe9e6;\n}\n\n.GeneratePage-clear-button {\n  display: grid;\n  width: 28px;\n  height: 28px;\n  place-items: center;\n  color: #7c867e;\n  background: #f5f7f5;\n  border: 1px solid #e2e8e3;\n  border-radius: 7px;\n  font-size: 11px;\n}\n\n.GeneratePage-clear-button:hover {\n  color: var(--canvas-ink, #171a17);\n  background: #eef3ed;\n}\n\n.GeneratePage-current-result {\n  display: flex;\n  min-width: 0;\n  min-height: 220px;\n  flex: 0 0 auto;\n  flex-direction: column;\n  justify-content: center;\n  overflow-y: auto;\n  scrollbar-width: thin;\n}\n\n.GeneratePage-empty-state {\n  display: flex;\n  min-height: 220px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n}\n\n.GeneratePage-empty-mark,\n.GeneratePage-processing-mark,\n.GeneratePage-error-mark {\n  display: grid;\n  place-items: center;\n  color: #739c52;\n  background: #edf6e7;\n  border-radius: 12px;\n}\n\n.GeneratePage-empty-mark {\n  width: 58px;\n  height: 58px;\n  margin-bottom: 18px;\n  font-size: 24px;\n}\n\n.GeneratePage-empty-state h3,\n.GeneratePage-processing-state h3,\n.GeneratePage-error-state h3 {\n  margin: 0;\n  color: var(--canvas-ink, #171a17);\n  font-size: 15px;\n  font-weight: 720;\n}\n\n.GeneratePage-empty-state p,\n.GeneratePage-processing-state p,\n.GeneratePage-error-state p {\n  max-width: 360px;\n  margin: 8px 0 0;\n  color: var(--canvas-muted, #737b75);\n  font-size: 11px;\n  line-height: 1.55;\n}\n\n.GeneratePage-empty-state.is-completed .GeneratePage-empty-mark {\n  color: #4e852e;\n  background: #e9f5df;\n}\n\n.GeneratePage-processing-state {\n  min-height: 220px;\n  padding: 28px 8px 8px;\n}\n\n.GeneratePage-processing-copy {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 13px;\n  text-align: left;\n}\n\n.GeneratePage-processing-mark {\n  width: 42px;\n  height: 42px;\n  flex: 0 0 42px;\n  font-size: 16px;\n  animation: GeneratePage-pulse 1.5s ease-in-out infinite;\n}\n\n.GeneratePage-skeleton-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 12px;\n  width: 100%;\n  max-width: 520px;\n  margin: 24px auto 0;\n}\n\n.GeneratePage-skeleton-grid span {\n  display: block;\n  aspect-ratio: 4 / 3;\n  background: linear-gradient(110deg, #eef2ee 20%, #f8faf8 38%, #eef2ee 56%);\n  background-size: 220% 100%;\n  border-radius: 10px;\n  animation: GeneratePage-shimmer 1.45s linear infinite;\n}\n\n.GeneratePage-media-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  padding-top: 18px;\n}\n\n.GeneratePage-current-result .GeneratePage-media-grid {\n  max-height: 320px;\n  overflow-y: auto;\n  padding-right: 2px;\n  scrollbar-width: thin;\n}\n\n.GeneratePage-media-result {\n  min-width: 0;\n  margin: 0;\n  overflow: hidden;\n  background: #f2f4f2;\n  border-radius: 10px;\n}\n\n.GeneratePage-media-result img,\n.GeneratePage-media-result video {\n  display: block;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  object-fit: cover;\n  background: #e9eeeb;\n}\n\n.GeneratePage-media-result.is-video video {\n  aspect-ratio: 16 / 9;\n  object-fit: contain;\n  background: #151814;\n}\n\n.GeneratePage-media-result figcaption {\n  display: flex;\n  min-height: 38px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 10px;\n  color: #78837b;\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 9px;\n}\n\n.GeneratePage-media-result figcaption a {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #4c7535;\n  font-family: inherit;\n  font-size: 9px;\n  text-decoration: none;\n}\n\n.GeneratePage-media-result figcaption a:hover {\n  color: #263d1c;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.GeneratePage-error-state {\n  display: flex;\n  min-height: 220px;\n  align-items: center;\n  justify-content: center;\n  gap: 13px;\n  padding: 32px;\n  text-align: left;\n}\n\n.GeneratePage-error-mark {\n  width: 42px;\n  height: 42px;\n  flex: 0 0 42px;\n  color: #b65745;\n  background: #fff0e8;\n  font-size: 17px;\n}\n\n.GeneratePage-error-state button {\n  flex: 0 0 auto;\n  min-height: 34px;\n  padding: 7px 11px;\n  color: #3f6530;\n  background: #eef7e7;\n  border: 1px solid #cee4bd;\n  border-radius: 7px;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.GeneratePage-error-state button:hover {\n  background: #e2f1d7;\n}\n\n.GeneratePage-history {\n  display: flex;\n  min-width: 0;\n  min-height: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #edf0ee;\n}\n\n.GeneratePage-history-header {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 9px;\n}\n\n.GeneratePage-history-header h3 {\n  margin: 0;\n  color: var(--canvas-ink, #171a17);\n  font-size: 12px;\n  font-weight: 720;\n  line-height: 1.3;\n}\n\n.GeneratePage-history-header p {\n  margin: 3px 0 0;\n  color: var(--canvas-muted, #737b75);\n  font-size: 9px;\n  line-height: 1.4;\n}\n\n.GeneratePage-history-count {\n  flex: 0 0 auto;\n  padding-top: 1px;\n  color: #809083;\n  font-size: 9px;\n  font-variant-numeric: tabular-nums;\n}\n\n.GeneratePage-history-list {\n  display: grid;\n  min-height: 0;\n  flex: 1 1 auto;\n  gap: 7px;\n  overflow-y: auto;\n  padding: 1px 3px 2px 0;\n  scrollbar-width: thin;\n}\n\n.GeneratePage-history-item {\n  display: grid;\n  grid-template-columns: 70px minmax(0, 1fr);\n  align-items: stretch;\n  gap: 9px;\n  min-width: 0;\n  min-height: 70px;\n  padding: 7px;\n  background: #fbfcfb;\n  border: 1px solid #e5ebe6;\n  border-radius: 8px;\n}\n\n.GeneratePage-history-thumb {\n  display: grid;\n  width: 70px;\n  height: 56px;\n  place-items: center;\n  overflow: hidden;\n  color: #72965d;\n  background: #edf4e9;\n  border-radius: 6px;\n  font-size: 15px;\n}\n\n.GeneratePage-history-thumb img,\n.GeneratePage-history-thumb video {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  background: #e9eeeb;\n}\n\n.GeneratePage-history-thumb.is-video video {\n  object-fit: contain;\n  background: #171b17;\n}\n\n.GeneratePage-history-thumb.is-audio {\n  color: #a06a35;\n  background: #fff2df;\n}\n\n.GeneratePage-history-thumb.is-empty {\n  color: #8a958d;\n  background: #f0f3f0;\n}\n\n.GeneratePage-history-item-body {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 4px;\n}\n\n.GeneratePage-history-item-header,\n.GeneratePage-history-item-footer {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.GeneratePage-history-item-header strong {\n  min-width: 0;\n  overflow: hidden;\n  color: #36443a;\n  font-size: 10px;\n  font-weight: 720;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.GeneratePage-history-status {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 4px;\n  font-size: 8px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.GeneratePage-history-status i {\n  width: 4px;\n  height: 4px;\n  background: currentColor;\n  border-radius: 50%;\n}\n\n.GeneratePage-history-status.is-processing {\n  color: #9a6a1e;\n}\n\n.GeneratePage-history-status.is-completed {\n  color: #4c7a2f;\n}\n\n.GeneratePage-history-status.is-failed {\n  color: #b55249;\n}\n\n.GeneratePage-history-item-body p {\n  display: -webkit-box;\n  min-width: 0;\n  margin: 0;\n  overflow: hidden;\n  color: #69746c;\n  font-size: 9px;\n  line-height: 1.4;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n}\n\n.GeneratePage-history-item-footer {\n  color: #8a958d;\n  font-size: 8px;\n  font-variant-numeric: tabular-nums;\n}\n\n.GeneratePage-history-item-footer span {\n  color: #6e846a;\n}\n\n.GeneratePage-history-state {\n  display: flex;\n  min-height: 82px;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 14px 8px;\n  color: #7e8980;\n  font-size: 9px;\n  text-align: center;\n}\n\n.GeneratePage-history-state > i {\n  color: #779b5c;\n  font-size: 13px;\n}\n\n.GeneratePage-history-state.is-error {\n  color: #ad5b4c;\n}\n\n.GeneratePage-history-login,\n.GeneratePage-history-retry {\n  min-height: 26px;\n  padding: 4px 8px;\n  color: #3f6530;\n  background: #eef7e7;\n  border: 1px solid #cee4bd;\n  border-radius: 6px;\n  font-size: 9px;\n  font-weight: 700;\n}\n\n.GeneratePage-history-login:hover,\n.GeneratePage-history-retry:hover {\n  background: #e2f1d7;\n}\n\n.GeneratePage-history-inline-error {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding-top: 6px;\n  color: #ad5b4c;\n  font-size: 8px;\n}\n\n.GeneratePage-history-load-more {\n  display: inline-flex;\n  min-height: 28px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  margin-top: 7px;\n  color: #5e7c52;\n  background: #f5f8f3;\n  border: 1px solid #dce9d5;\n  border-radius: 7px;\n  font-size: 9px;\n  font-weight: 700;\n}\n\n.GeneratePage-history-load-more:hover:not(:disabled) {\n  color: #36512d;\n  background: #edf6e8;\n  border-color: #c7dbbd;\n}\n\n.GeneratePage-history-load-more:disabled {\n  cursor: wait;\n  opacity: 0.6;\n}\n\n.GeneratePage-current-result::-webkit-scrollbar,\n.GeneratePage-current-result .GeneratePage-media-grid::-webkit-scrollbar,\n.GeneratePage-history-list::-webkit-scrollbar {\n  width: 7px;\n}\n\n.GeneratePage-current-result::-webkit-scrollbar-thumb,\n.GeneratePage-current-result .GeneratePage-media-grid::-webkit-scrollbar-thumb,\n.GeneratePage-history-list::-webkit-scrollbar-thumb {\n  background: #cbd8c9;\n  border-radius: 999px;\n}\n\n.GeneratePage-current-result::-webkit-scrollbar-track,\n.GeneratePage-current-result .GeneratePage-media-grid::-webkit-scrollbar-track,\n.GeneratePage-history-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n@keyframes GeneratePage-pulse {\n  50% { transform: scale(0.92); opacity: 0.65; }\n}\n\n@keyframes GeneratePage-shimmer {\n  to { background-position: -220% 0; }\n}\n\n@keyframes GeneratePage-spin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes GeneratePage-menu-enter {\n  from { opacity: 0; transform: translateY(-4px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@media (min-width: 901px) and (max-height: 800px) {\n  .GeneratePage-main {\n    padding-top: 12px;\n    padding-bottom: 18px;\n  }\n\n  .GeneratePage-header {\n    min-height: 34px;\n    padding-bottom: 10px;\n  }\n\n  .GeneratePage-header h1 {\n    font-size: 25px;\n  }\n\n  .GeneratePage-workspace {\n    gap: 16px;\n    padding-top: 12px;\n  }\n\n  .GeneratePage-controls {\n    padding: 9px 14px 8px;\n  }\n\n  .GeneratePage-section {\n    margin-bottom: 6px;\n    padding-bottom: 6px;\n  }\n\n  .GeneratePage-section-heading {\n    margin-bottom: 4px;\n  }\n\n  .GeneratePage-section-heading h2 {\n    font-size: 14px;\n  }\n\n  .GeneratePage-section-heading p {\n    font-size: 9px;\n  }\n\n  .GeneratePage-reference-section .GeneratePage-section-heading {\n    margin-bottom: 4px;\n  }\n\n  .GeneratePage-reference-section .GeneratePage-section-heading p {\n    max-width: 220px;\n    font-size: 8px;\n  }\n\n  .GeneratePage-reference-add {\n    min-height: 28px;\n    padding: 4px 6px;\n    font-size: 8px;\n  }\n\n  .GeneratePage-reference-add > i {\n    font-size: 10px;\n  }\n\n  .GeneratePage-reference-add small,\n  .GeneratePage-reference-meta,\n  .GeneratePage-reference-notice,\n  .GeneratePage-reference-error {\n    font-size: 7px;\n  }\n\n  .GeneratePage-reference-list {\n    max-height: 84px;\n  }\n\n  .GeneratePage-params-toggle {\n    grid-template-columns: 25px minmax(0, 1fr) auto;\n    min-height: 32px;\n  }\n\n  .GeneratePage-params-toggle-mark {\n    width: 25px;\n    height: 25px;\n    font-size: 11px;\n  }\n\n  .GeneratePage-params-toggle-copy strong {\n    font-size: 10px;\n  }\n\n  .GeneratePage-params-toggle-copy small,\n  .GeneratePage-params-toggle-action em {\n    font-size: 7px;\n  }\n\n  .GeneratePage-params-panel {\n    padding-top: 5px;\n  }\n\n  .GeneratePage-model-tabs {\n    gap: 5px;\n    margin-bottom: 5px;\n  }\n\n  .GeneratePage-model-tab {\n    min-height: 26px;\n    padding: 4px 7px;\n    font-size: 9px;\n  }\n\n  .GeneratePage-model-picker-trigger {\n    grid-template-columns: 28px minmax(0, 1fr) auto;\n    gap: 7px;\n    min-height: 44px;\n    padding: 7px 8px;\n  }\n\n  .GeneratePage-model-mark {\n    width: 25px;\n    height: 25px;\n    font-size: 12px;\n  }\n\n  .GeneratePage-model-picker-copy {\n    gap: 2px;\n  }\n\n  .GeneratePage-model-picker-copy strong {\n    font-size: 11px;\n  }\n\n  .GeneratePage-model-picker-copy small {\n    font-size: 8px;\n  }\n\n  .GeneratePage-prompt-field textarea {\n    height: 70px;\n    min-height: 70px;\n    max-height: 70px;\n    padding: 8px 9px 24px;\n    font-size: 10px;\n  }\n\n  .GeneratePage-field-grid {\n    gap: 6px;\n  }\n\n  .GeneratePage-option-field {\n    gap: 3px;\n  }\n\n  .GeneratePage-option-field > span,\n  .GeneratePage-choice-field legend {\n    font-size: 8px;\n  }\n\n  .GeneratePage-option-trigger {\n    min-height: 30px;\n    padding: 0 8px;\n    font-size: 9px;\n  }\n\n  .GeneratePage-choice-field {\n    margin-top: 7px;\n  }\n\n  .GeneratePage-quality-options {\n    gap: 4px;\n  }\n\n  .GeneratePage-quality-options button {\n    min-height: 32px;\n    gap: 1px;\n    padding: 4px 6px;\n  }\n\n  .GeneratePage-quality-options strong {\n    font-size: 8px;\n  }\n\n  .GeneratePage-quality-options small {\n    font-size: 7px;\n  }\n\n  .GeneratePage-audio-toggle {\n    min-height: 24px;\n    margin-top: 6px;\n    font-size: 8px;\n  }\n\n  .GeneratePage-parameter-note {\n    gap: 5px;\n    margin-top: 4px;\n    font-size: 8px;\n  }\n\n  .GeneratePage-submit-area {\n    gap: 6px;\n  }\n\n  .GeneratePage-quote {\n    min-height: 31px;\n    padding: 4px 7px;\n  }\n\n  .GeneratePage-quote-icon {\n    width: 20px;\n    height: 20px;\n    flex-basis: 20px;\n    font-size: 10px;\n  }\n\n  .GeneratePage-quote strong {\n    font-size: 8px;\n  }\n\n  .GeneratePage-quote small {\n    font-size: 7px;\n  }\n\n  .GeneratePage-submit {\n    min-height: 34px;\n    font-size: 10px;\n  }\n}\n\n@media (max-width: 1080px) {\n  .GeneratePage-main { padding-right: 24px; padding-left: 24px; }\n  .GeneratePage-workspace { grid-template-columns: minmax(300px, 350px) minmax(0, 1fr); gap: 18px; }\n  .GeneratePage-controls,\n  .GeneratePage-results { padding-right: 18px; padding-left: 18px; }\n}\n\n@media (max-width: 900px) {\n  .GeneratePage-workspace { grid-template-columns: 1fr; }\n  .GeneratePage-controls { position: static; }\n  .GeneratePage-results {\n    height: auto;\n    min-height: 520px;\n    max-height: none;\n    overflow: visible;\n  }\n  .GeneratePage-current-result {\n    max-height: none;\n    overflow: visible;\n  }\n  .GeneratePage-history-list {\n    max-height: 280px;\n    flex: 0 1 280px;\n  }\n}\n\n@media (max-width: 720px) {\n  .GeneratePage-root { margin-left: 68px; }\n  .GeneratePage-main { padding: 14px 10px 28px; }\n  .GeneratePage-header { align-items: flex-start; flex-direction: column; gap: 8px; padding-bottom: 12px; }\n  .GeneratePage-header h1 { font-size: 24px; }\n  .GeneratePage-workspace { padding-top: 12px; }\n  .GeneratePage-controls,\n  .GeneratePage-results { border-radius: 11px; }\n  .GeneratePage-controls { padding: 12px 12px 10px; }\n  .GeneratePage-results { padding: 16px; }\n  .GeneratePage-section { margin-bottom: 10px; padding-bottom: 10px; }\n  .GeneratePage-section-heading { margin-bottom: 7px; }\n  .GeneratePage-prompt-field textarea {\n    height: 88px;\n    min-height: 88px;\n    max-height: 88px;\n  }\n  .GeneratePage-empty-state,\n  .GeneratePage-processing-state { min-height: 260px; }\n  .GeneratePage-media-grid { grid-template-columns: 1fr; }\n  .GeneratePage-error-state { align-items: flex-start; flex-wrap: wrap; justify-content: flex-start; padding: 28px 8px; }\n  .GeneratePage-error-state button { margin-left: 55px; }\n}\n\n@media (max-width: 440px) {\n  .GeneratePage-field-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .GeneratePage-quality-options { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n  .GeneratePage-quality-options button {\n    min-height: 42px;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n  }\n  .GeneratePage-model-copy small { white-space: normal; }\n  .GeneratePage-results-header { flex-direction: column; }\n  .GeneratePage-result-actions { align-self: flex-start; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .GeneratePage-model-option,\n  .GeneratePage-model-tab,\n  .GeneratePage-model-picker-trigger,\n  .GeneratePage-option-trigger,\n  .GeneratePage-submit,\n  .GeneratePage-prompt-field textarea { transition: none; }\n  .GeneratePage-quote.is-loading .GeneratePage-quote-icon,\n  .GeneratePage-processing-mark,\n  .GeneratePage-skeleton-grid span,\n  .GeneratePage-spin,\n  .GeneratePage-model-menu,\n  .GeneratePage-option-list,\n  .GeneratePage-params-panel { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
